module.exports = __webpack_public_path__ + "media/application/images/icons/close_search-08449dc8c4919c6175dc6e932b4bccda.svg";